'use client';
import { useState, useEffect } from 'react';
import ServicesHeroSection from './ServicesHeroSection';
import ServicesListSection from './ServicesListSection';
import ContactSection from './ContactSection';
import FooterSection from './FooterSection';

interface ServiceItem {
  id: number;
  title: string;
  description: string;
  icon: string;
  image: string;
  items: string[];
  reversed?: boolean;
}

export default function ServicesPageComponent() {
  const [services, setServices] = useState<ServiceItem[]>([]);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async (): Promise<void> => {
    try {
      setTimeout(() => {
        setServices([
          {
            id: 1,
            title: 'Strategy & Business advisory',
            description: 'We help organizations create resilient strategies, informed decisions, and translate vision into actionable plans that drive sustainable growth.',
            icon: '/images/service1.png',
            image: '/images/img_service1.png',
            items: [
              'Business Strategy Development',
              'Corporate Restructuring',
              'Performance Optimization',
              'Market Entry Planning',
              'Investment Appraisal'
            ],
            reversed: false
          },
          {
            id: 2,
            title: 'Microfinance & Financial Consulting',
            description: 'We support microfinance institutions and financial organizations with strategic guidance, operational improvement, and sustainable growth enablement.',
            icon: '/images/service2.png',
            image: '/images/img_service2.png',
            items: [
              'Regulatory Compliance',
              'Risk Management',
              'Loan Portfolio',
              'Quality Improvement',
              'Digital Transformation for Microfinance'
            ],
            reversed: true
          },
          {
            id: 3,
            title: 'Training & Capacity Building',
            description: 'We design and deliver practical training programs that strengthen leadership, build organizational capacity, and improve organizational performance',
            icon: '/images/service3.png',
            image: '/images/img_service3.png',
            items: [
              'Governance and Board Training',
              'Management capacity development',
              'Financial literacy Programmes',
              'Staff  capacity development',
              'Board training'
            ],
            reversed: false
          },
          {
            id: 4,
            title: 'Legal, Governance & Compliance',
            description: 'We help organizations strengthen governance structures, manage risk, and maintain compliance through sound legal and regulatory adherence.',
            icon: '/images/service4.png',
            image: '/images/img_service4.png',
            items: [
              'Corporate governance advisory',
              'Compliance audit',
              'regulatory filings',
              'Legal risk assesment'
            ],
            reversed: true
          },
          {
            id: 5,
            title: 'Technology & Digital Advisory',
            description: 'We guide organizations in leveraging technology and digital solutions to improve efficiency, enhance decision-making, and support strategic growth.',
            icon: '/images/service5.png',
            image: '/images/img_service5.png',
            items: [
              'IT Systems evaluation',
              'Enterprise solutions',
              'Fintech advisory',
              'cybersecurity',
              'Emerging Technologies (AI,Blockchain)'
            ],
            reversed: false
          },
          {
            id: 6,
            title: 'Real Estate & Property Advisory',
            description: 'We provide strategic insight and advisory services that support informed real estate decisions, optimize property investments, and manage the effciently',
            icon: '/images/service6.png',
            image: '/images/img_service6.png',
            items: [
              'Property investment advisory',
              'project finance',
              'Facilities management solutions',
              'Asset management solutions'
            ],
            reversed: true
          }
        ]);
      }, 500);
    } catch (error) {
      console.error('Error loading services:', error);
    }
  };

  return (
    <>
      <main data-component-id="src/components/sections/ServicesPageComponent.tsx:126:6" data-component-path="src/components/sections/ServicesPageComponent.tsx" data-component-line="126" data-component-end-line="131" data-component-file="ServicesPageComponent.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%7D">
        <ServicesHeroSection data-component-id="src/components/sections/ServicesPageComponent.tsx:127:8" data-component-path="src/components/sections/ServicesPageComponent.tsx" data-component-line="127" data-component-end-line="127" data-component-file="ServicesPageComponent.tsx" data-component-name="ServicesHeroSection" data-component-content="%7B%22elementName%22%3A%22ServicesHeroSection%22%7D" />
        <ServicesListSection data-component-id="src/components/sections/ServicesPageComponent.tsx:128:8" data-component-path="src/components/sections/ServicesPageComponent.tsx" data-component-line="128" data-component-end-line="128" data-component-file="ServicesPageComponent.tsx" data-component-name="ServicesListSection" data-component-content="%7B%22elementName%22%3A%22ServicesListSection%22%7D" services={services} />
        <ContactSection data-component-id="src/components/sections/ServicesPageComponent.tsx:129:8" data-component-path="src/components/sections/ServicesPageComponent.tsx" data-component-line="129" data-component-end-line="129" data-component-file="ServicesPageComponent.tsx" data-component-name="ContactSection" data-component-content="%7B%22elementName%22%3A%22ContactSection%22%7D" />
        <FooterSection data-component-id="src/components/sections/ServicesPageComponent.tsx:130:8" data-component-path="src/components/sections/ServicesPageComponent.tsx" data-component-line="130" data-component-end-line="130" data-component-file="ServicesPageComponent.tsx" data-component-name="FooterSection" data-component-content="%7B%22elementName%22%3A%22FooterSection%22%7D" />
      </main>
    </>
  );
}
